
import { excludedCountries2Step } from  "../services/api"

export function createPassportsList(portfolioData) {
    const passportOptions = portfolioData.filter(row => (row.iso_code !== 'JEY'))
        .map((row,index) => {
        return { 
            value: row.iso_code + index, 
            label: row.country,
            iso_code: row.iso_code, 
            cardType:'Passport',
            type:false,
        }
    }).sort((a, b) => 
        a.label.localeCompare(b.label)
    );

    return passportOptions;
}

export function createRcbiList(portfolioData) {
    const filteredList = portfolioData
    .filter(row => {
        /*
        if (row.iso_code == 'AUT'  &&  ( row.cpi === true || row.cbn === true)) {
            return false
        }
        */

        if (excludedCountries2Step.indexOf(row.iso_code) > -1) {
            return false;
        }

        return true;
    })
    .filter(row => row.cpi === true || row.rpi === true || row.cbn === true)
        .map(row => {
            if (row.iso_code == 'AUT' ) {
                return { iso_code: row.iso_code, country: row.country, cpi: false, rpi: row.rpi, cbn: false}    
            }
            return { iso_code: row.iso_code, country: row.country, cpi: row.cpi, rpi: row.rpi, cbn: row.cbn }
        });
    
    const rbiList= filteredList.map((d) => {
        let cardType = '';
        if(d.cpi === true && d.rpi === false){
            cardType = 'CBI';
        }else if(d.rpi === true && d.cpi === false){
            cardType = 'RBI';
        }

        let type = '';

        if(d.cpi === true && d.rpi === false){
            type = 'cpi';
        }else if(d.rpi === true && d.cpi === false){
            type = 'rpi';
        }

        return { 
            value: d.iso_code + '-' + cardType, 
            label: d.country, 
            iso_code: d.iso_code, 
            cardType:cardType, 
            type: type 
        };
    });

    const cbnList = filteredList.filter((d)=>{
        return d.cbn === true;
    }).map((d)=>{
        return {value: d.iso_code + '-CBN', label: d.country, iso_code: d.iso_code, cardType: 'CBN', type: 'cbn'}
    });

    const combinedList = rbiList.concat(cbnList);

    const sortedList = combinedList.sort((a, b) => 
        a.label.localeCompare(b.label)
    );

    return sortedList;
}